import classnames from "classnames";
import type { ListCollection } from "@ark-ui/react";

import { BoundsPreviewMap } from "@/features/widget-forms/forms/weather-model-map/components/bounds-preview-map";
import Select from "@/components/select/select";
import type { ParametersGeoBoundingBox } from "@/lib/api";
import dialogStyles from "@/features/widget-forms/forms/weather-model-map/weather-model-map-dialog.module.css";

export type BaseLayerStylePanelStrings = {
  title: string;
  subtitle: string;
  styleLabel: string;
};

type BaseLayerStylePanelProps = {
  strings: BaseLayerStylePanelStrings;
  collection: ListCollection<{ label: string; value: string }>;
  value: string;
  onValueChange: (value: string) => void;
  fieldName: string;
  previewBounds: ParametersGeoBoundingBox;
  baseLayerStyle: string;
};

export function BaseLayerStylePanel({
  strings,
  collection,
  value,
  onValueChange,
  fieldName,
  previewBounds,
  baseLayerStyle,
}: BaseLayerStylePanelProps) {
  return (
    <div
      className={classnames(
        dialogStyles.tabContentWrapper,
        dialogStyles.baseLayerStyleTabPad,
      )}
    >
      <div className={dialogStyles.baseLayerStyleTabHeader}>
        <h2 className={dialogStyles.baseLayerStyleTabTitle}>{strings.title}</h2>
        <p className={dialogStyles.baseLayerStyleTabSubtitle}>{strings.subtitle}</p>
      </div>
      <div className={dialogStyles.baseLayerStyleField}>
        <Select
          label={strings.styleLabel}
          collection={collection}
          value={value}
          onValueChange={onValueChange}
          name={fieldName}
        />
      </div>
      <div className={dialogStyles.baseLayerStyleBoundsPreviewInTab}>
        <BoundsPreviewMap
          bounds={previewBounds}
          fitBoundsPadding={0}
          baseLayerStyle={baseLayerStyle}
          boundsInteractionMode="none"
        />
      </div>
    </div>
  );
}
